
import Vue from 'vue'
import Vuex from 'vuex'
import user, { TYPE as userType } from './modules/user'
import menuStart, { TYPE as menuType } from './modules/menuStart'


import { deepClone } from '@/common.js'

Vue.use(Vuex)

let withNS = function (o, ns) {
  for (let i in o) {
    let _ns = ns
    if (!_ns) _ns = i
    if (typeof (o[i]) !== typeof ('')) withNS(o[i], _ns)
    else o[i] = _ns + '/' + o[i]
  }
  return o
}

let store = new Vuex.Store({
  modules: {
    user,
    menuStart
  }
})

export const TYPE = withNS(deepClone({
  user: userType,
  menuStart: menuType,
}))

export default store
